import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  Skeleton,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  IconButton
} from "@mui/material";
import React, { useContext, useRef, useState } from "react";
import MUIToolTip from "../../../Component/UI/ActionTooltip/MUIToolTip";
import ErrorView from "../../../Component/ErrorView/ErrorView";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import { extractDomain } from "../../../utils/helpers";
import { DiscoveryContext } from "../discovery-context";
import useGenerateProductTaxonomies from "../useGenerateProductTaxonomies";
import MUICard from "./../../../Component/UI/MUICard/MUICard";
import MUITable, {
  StyledTableCell,
  StyledTableRow,
} from "./../../../Component/UI/Table/Table";
import classes from "./Taxonomy.module.css";
import { AuthContext } from "../../../context/auth-context";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import {
  createActionMetric,
  fetchActionMetrics,
} from "../../../redux/actions/metricActions";
import {
  formatSourceData,
  formatOldSourceData,
} from "../../../utils/metric-sources";
import BrandAvatar from "../../../Component/Avatar/Avatar"
import { ENTITY_LABELS } from "../../../utils/labelMapping";
import useBaseResponsesModal from "../../../Component/BaseResponseComponent/useBaseResponsesModal";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import BaseResponsesModal from "../../../Component/BaseResponseComponent/BaseResponsesModal";



function Row({ data, category, isReporting }) {
  const [open, setOpen] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const { user } = useContext(AuthContext);
  const discoveryCtx = useContext(DiscoveryContext);
  const customerId = user?.customer_id;
  const llm = discoveryCtx.state.selectedLLM;
  const persona = discoveryCtx?.state?.selectedPersona;
  const market = discoveryCtx.markets[0];
  const type = discoveryCtx.type;
  const dispatch = useDispatch();
  const showOldSourcesRecord =
    discoveryCtx.state.sourceValidationStatus === "PENDING";
  const isValidated =
    discoveryCtx?.taxonomies?.[llm]?.[category]?.[market]?.[persona].isValidated || false;
  const sourceTaxonomy =
    discoveryCtx?.taxonomies?.[llm]?.[category]?.[market]?.[persona].sources || [];
  function roundNumber(num) {
    return num % 1 < 0.5 ? Math.floor(num) : Math.ceil(num);
  }

  const saveActions = async (actionStatement, explanation, sources, brand) => {
    setIsActionLoading(true);
    const modifiedObj = {
      title: actionStatement,
      rationale: explanation,
      brand,
      persona: "General Persona",
      geography: market == "General Market" ? "General Location" : market,
      market: "General Market",
      category,
      llm,
      isProduct: type === "product" ? true : false,
      sources,
    };

    const payload = {
      action_json: [modifiedObj],
      is_archived: 0,
      is_active: 1,
    };
    dispatch(createActionMetric(customerId, payload))
      .then(() => {
        dispatch(fetchActionMetrics(customerId));
        setIsActionLoading(false);
        toast.success("Action Added!", {
          autoClose: 700,
        });
      })
      .catch(() => {
        setIsActionLoading(false);
        toast.error("Something went wrong!", {
          autoClose: 700,
        });
      });
  };

  return (
    <React.Fragment key={data.name}>
      <StyledTableRow>
        <StyledTableCell className={classes.attribute_headings}>
          <div className={classes.heading_wrapper}>
            <MUIIconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </MUIIconButton>
            <span className={classes.heading_text}>
              {data.name.replace(/\bProduct\b/g, ENTITY_LABELS.product)}
            </span>
          </div>
        </StyledTableCell>
        {data?.products?.map((product, index) => {
          let color = "#dc3545";
          let rating = "low";
          if (product?.score >= 7) {
            rating = "fair";
            color = "#2196F3";
          }
          if (product?.score >= 9) {
            rating = "high";
            color = "#198754";
          }

          const attributeSources =
            Array.isArray(product?.sources) && product?.sources?.length > 0
              ? product?.sources
              : sourceTaxonomy;
          const isCustomTooltip =
            product?.name?.toLowerCase() ===
            discoveryCtx.entity?.toLowerCase() &&
            llm?.toLowerCase()?.includes("search") &&
            (showOldSourcesRecord || isValidated);

          const sources = isCustomTooltip
            ? showOldSourcesRecord
              ? formatOldSourceData(attributeSources, llm)
              : formatSourceData(attributeSources, llm)
            : {};
          const TooltipComponent = isCustomTooltip ? MUIToolTip : Tooltip;
          const tooltipProps = isCustomTooltip
            ? {
              metric: ENTITY_LABELS.productDimension,
              attribute: data.name,
              metricScore: Number(product?.score).toFixed(0),
              selectedInput: {
                llm,
                market: "General Market",
                category,
                brand: product.name,
                product: product.name,
                persona: "General Persona",
                geography:
                  market == "General Market" ? "General Location" : market,
              },
              addToActionHandler: saveActions,
              actionText: "Add To Action",
              isActionLoading: isActionLoading,
              title: product?.explanation,
              arrow: true,
              targetKey: discoveryCtx?.entity,
              isDiscovery: index,
              isBrandAudit: true,
              sources,
              slotProps: {
                popper: {
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [0, -18],
                      },
                    },
                  ],
                },
              },
            }
            : {
              title: product?.explanation,
              arrow: true,
              slotProps: {
                popper: {
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [0, -18],
                      },
                    },
                  ],
                },
              },
            };

          return (
            <>
              {isReporting ? (
                <TooltipComponent {...tooltipProps}>
                  <StyledTableCell
                    style={{ color }}
                    className={classes.attribute_score}
                    key={product.name}
                  >
                    {roundNumber(product.score) || 0}
                  </StyledTableCell>
                </TooltipComponent>
              ) : (
                <StyledTableCell
                  style={{ color }}
                  className={classes.attribute_score}
                  key={product.name}
                >
                  {roundNumber(product.score) || 0}
                </StyledTableCell>
              )}
            </>
          );
        })}
      </StyledTableRow>
      {open &&
        data?.products?.[0]?.subcategories?.map((sub, idx) => (
          <StyledTableRow key={idx} className={classes.sub_row}>
            <StyledTableCell className={classes.attribute_sub_headings}>
              {sub?.name}
            </StyledTableCell>
            {data?.products.map((product, jdx) => {
              let color = "#dc3545";
              const item = product?.subcategories?.[idx];
              if (item?.score >= 7) {
                color = "#2196F3";
              }
              if (item?.score >= 9) {
                color = "#198754";
              }

              return (
                <Tooltip
                  title={item?.explanation}
                  arrow
                  slotProps={{
                    popper: {
                      modifiers: [
                        {
                          name: "offset",
                          options: {
                            offset: [0, -18],
                          },
                        },
                      ],
                    },
                  }}
                >
                  <StyledTableCell
                    style={{ color }}
                    className={classes.attribute_score}
                  >
                    {roundNumber(product?.subcategories?.[idx]?.score) || 0}
                  </StyledTableCell>
                </Tooltip>
              );
            })}
          </StyledTableRow>
        ))}
    </React.Fragment>
  );
}

export default function Taxonomy({ category }) {
  const discoveryCtx = useContext(DiscoveryContext);
  const { user } = useContext(AuthContext);
  const { custom_taxonomies } = useGenerateProductTaxonomies();
  const searchParams = new URLSearchParams(window.location.search);
  const entity = discoveryCtx?.entity;
  const isReporting = searchParams.get("isReporting") === "true";
  const llm = discoveryCtx?.state?.selectedLLM;
  const market = discoveryCtx?.market;
  const persona = discoveryCtx?.state?.selectedPersona;
  const isCompanyUser = user?.user_role?.role?.name === "Company user";
  const baseResponsesData = discoveryCtx?.taxonomies?.[llm]?.[category]?.[market]?.[persona]?.baseResponse || {};
  const {
     infoModalOpen,
     infoModalTitle,
     infoModalContent,
     closeInfoModal,
     handleTaxonomyClick,
   } = useBaseResponsesModal({ baseResponses: baseResponsesData }, "taxonomy");
  console.log("baseResponsesDataTaxonomy",baseResponsesData)
const TABLE_HEADERS = [
  {
    id: "taxonomy",
    name: ENTITY_LABELS.productDimension,
  },
];
  function LoadingSkeletion() {
    return (
      <div className="p-3">
        <Skeleton variant="rectangular" height={30} />
        {Array(10)
          .fill(0)
          .map((_, index) => (
            <Skeleton
              variant="rectangular"
              width={index % 2 === 0 ? "70%" : "97%"}
              key={index}
              className="my-3"
              height={20}
            />
          ))}
      </div>
    );
  }

  function renderHeaders() {
    const headers = [
      ...TABLE_HEADERS,
      ...discoveryCtx.competitors["default"].map((item) => ({
        id: item.name,
        name: item.name,
      })),
      ...discoveryCtx.competitors[category].map((item) => ({
        id: item.name,
        name: item.name,
      })),
    ];

    return (
      <TableHead className={classes.table_head}>
        <TableRow>
          {headers.map((header, index) => {
            let ctxCompetitor = null;
            if (index == 1) {
              ctxCompetitor = discoveryCtx.competitors["default"][0];
            }
            if (index > 1) {
              ctxCompetitor = discoveryCtx.competitors[category][index - 2];
            }

            let domain = "";
            if (ctxCompetitor && ctxCompetitor?.domain) {
              domain = extractDomain(ctxCompetitor?.domain);
            }

            return (
              <TableCell key={index} className={classes.table_head_cell}>
                  <div className={classes.table_head_content}>
                     {index !== 0 ? (
                    <>
                      {/* Logo with Info Icon overlay */}
                      <div className={classes.logo_container}>
                        <BrandAvatar
                          domainName={domain}
                          brandName={header.name}
                        />

                        {!isCompanyUser && Object.keys(baseResponsesData)?.length > 0  && (
                          <div className={classes.info_icon_wrapper}>
                            <Tooltip title="View Base Prompt" arrow placement="top">
                              <IconButton
                                size="small"
                                onClick={() => handleTaxonomyClick(header.name,entity, baseResponsesData)}
                                sx={{
                                  padding: '1px',                             
                                  backgroundColor: 'rgba(255, 255, 255, 0.95)',
                                  color: 'rgba(0, 0, 0, 0.54)',
                                  border: '1px solid rgba(0,0,0,0.08)',        
                                  '&:hover': {
                                    backgroundColor: '#2196F3',
                                    color: '#fff',
                                    border: '1px solid #2196F3',
                                  },
                                  boxShadow: '0 1px 4px rgba(0,0,0,0.18)',
                                }}
                              >
                                <InfoOutlinedIcon sx={{ fontSize: '13px' }} /> 
                              </IconButton>
                            </Tooltip>
                          </div>
                        )}
                      </div>

                      {/* Brand Name below logo */}
                      <div className={classes.table_head_text}>
                        {header.name}
                      </div>
                    </>
                  ) : (
                    <div className={classes.table_head_text_comp}>
                      <div className={classes.table_head_title}>
                        <span>{header.name}</span>
                      </div>
                    </div>
                  )}
                  </div>
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
    );
  }

  function roundNumber(num) {
    return num % 1 < 0.5 ? Math.floor(num) : Math.ceil(num);
  }

  function renderRows(data) {
    return (
      <Row
        key={data.name}
        data={data}
        category={category}
        isReporting={isReporting}
      />
    );
  }

  let loading = true;
  let hasError = false;
  let categories = [];
  let sortedCategories = [];
  const transactionStatus = discoveryCtx.state.transactionStatus;
  console.log(
    "transactionStatusRecord",
    discoveryCtx?.taxonomies?.[llm]?.[category]?.[market]?.[persona]
  );

  if (
    discoveryCtx?.taxonomies &&
    Object.keys(discoveryCtx?.taxonomies?.[llm]?.[category]?.[market]?.[persona]?.data || {})
      .length > 0
  ) {
    categories = discoveryCtx?.taxonomies?.[llm]?.[category]?.[market]?.[persona]?.data?.categories.map((categoryRecord) => ({
      name: categoryRecord.name,
      products: discoveryCtx?.taxonomies?.[llm]?.[category]?.[market]?.[persona]?.data?.products.map(
        (product) => {
          const categoryScores = product?.scores?.[categoryRecord.name];
          const subcategories = Object.values(
            product.scores[categoryRecord.name]?.subcategories || {}
          );
          const totalScore = subcategories.length
            ? subcategories.reduce(
              (acc, item) => acc + (isNaN(+item.score) ? 0 : +item.score),
              0
            )
            : 0;
          const average = subcategories.length
            ? totalScore / subcategories.length
            : 0;
          //  Merge all subcategory sources (no subcategory field)
          const categoriesSources = Object.keys(
            categoryScores?.subcategories || {}
          ).reduce((acc, subcat) => {
            const subSources =
              categoryScores?.subcategories?.[subcat]?.sources || [];
            return [...acc, ...subSources];
          }, []);

          return {
            name: product.name,
            score: roundNumber(average),
            sources: categoriesSources,
            subcategories:
              Object.keys(
                product.scores[categoryRecord.name]?.subcategories || {}
              )?.map((subcat) => ({
                name: subcat,
                sources:
                  product.scores[categoryRecord.name]?.subcategories?.[subcat]?.sources || [],
                score:
                  product.scores[categoryRecord.name]?.subcategories?.[subcat]?.score || 0,
                explanation:
                  product.scores[categoryRecord.name]?.subcategories?.[subcat]?.explanation || "",
              })) || [],
          };
        }
      ),
    }));

    const headerOrder = [
      ...discoveryCtx.competitors["default"].map((item) => item.name.trim()),
      ...discoveryCtx.competitors[category].map((item) => item.name.trim()),
    ];

    sortedCategories = categories.map((cat) => ({
      ...cat,
      products: [...cat.products].sort(
        (a, b) =>
          headerOrder.indexOf(a.name.trim()) -
          headerOrder.indexOf(b.name.trim())
      ),
    }));

    loading = false;
  } else if (transactionStatus === "RETRY") {
    hasError = true;
    loading = false;
  } else if (transactionStatus === "RUNNING") {
    hasError = false;
    loading = true;
  }

  return (
    <MUICard variant="elevated" elevation={0} className={classes.card}>
      {!loading && !hasError && categories?.length > 0 && (
        <MUITable
          elevation={0}
          data={sortedCategories}
          renderHeaders={() => renderHeaders()}
          render={renderRows}
        />
      )}
      {hasError && (
        <div className={classes.error}>
          <ErrorView
            title={`Error Fetching ${ENTITY_LABELS.productDimension}`}
            message={"Request Failed"}
          />
        </div>
      )}
      <BaseResponsesModal
        open={infoModalOpen}
        title={infoModalTitle}
        content={infoModalContent}
        onClose={closeInfoModal}
       />
      {loading && !hasError && <LoadingSkeletion />}
    </MUICard>
  );
}
